import React from "react";
import { ArrowUpRight, CalendarDays } from "lucide-react";
import { actualites } from "../mock";
import useReveal from "../hooks/useReveal";

function Article({ a, i }) {
  const [ref, inView] = useReveal();
  return (
    <article
      ref={ref}
      className={`group bg-card rounded-2xl overflow-hidden border border-border hover:shadow-xl transition-shadow duration-400 reveal ${
        inView ? "in-view" : ""
      }`}
      style={{ animationDelay: `${i * 0.12}s` }}
    >
      <div className="relative overflow-hidden h-56">
        <img
          src={a.img}
          alt={a.title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <span className="absolute top-4 left-4 bg-accent text-accent-foreground text-xs font-medium tracking-wide px-3 py-1 rounded-full">
          {a.tag}
        </span>
      </div>
      <div className="p-6">
        <div className="flex items-center gap-2 text-muted-foreground text-xs mb-3">
          <CalendarDays className="h-3.5 w-3.5" /> {a.date}
        </div>
        <h3 className="font-serif text-xl font-semibold text-foreground leading-snug group-hover:text-accent transition-colors">
          {a.title}
        </h3>
        <p className="text-muted-foreground text-[15px] mt-3 leading-relaxed">{a.excerpt}</p>
        <button className="inline-flex items-center gap-1.5 mt-5 text-accent text-sm font-medium">
          Lire l'article <ArrowUpRight className="h-4 w-4" />
        </button>
      </div>
    </article>
  );
}

export default function Actualites() {
  return (
    <section id="actualites" className="py-24 md:py-32 bg-background">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="eyebrow-line text-accent tracking-[0.3em] text-xs font-medium uppercase">
            Actualités
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold mt-5 text-foreground">
            Conseils & actualités immobilières
          </h2>
          <p className="text-muted-foreground mt-4 text-lg">
            Nos experts partagent leurs conseils pour réussir vos projets d'achat, de vente et de location.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {actualites.map((a, i) => (
            <Article key={a.id} a={a} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
